import PropTypes from 'prop-types';
import {IntervalsLine, Legend, LegendHeader} from '../../../../../atoms/Legend';
import './style.scss';

const ZonesLegend = ({style}) => {
	if (style) {
		const data = style?.data;
		const {definition, description, nameInternal} = data;
		const styles = definition?.rules?.[0]?.styles;

		return (
			<div className="insar-ZonesLegend-wrapper">
				<Legend>
					<LegendHeader title={nameInternal} subtitle={description} />
					<IntervalsLine
						styleProperty="fill"
						classes={styles?.[1]?.attributeClasses}
						noData={styles?.[0]?.fill}
						longerTails
					/>
				</Legend>
			</div>
		);
	} else {
		return null;
	}
};

ZonesLegend.propTypes = {
	style: PropTypes.object,
};

export default ZonesLegend;
